import { createContext, useContext } from "react";

export const OutsideMenuContext = createContext({
  open: () => {},
});

export function useOpenOutsideMenu() {
  return useContext(OutsideMenuContext).open;
}
